import { AIAgentPaths, aiEditPath } from "./Pages/paths";

/**
 * AI Agents metadata source of truth.
 *
 * Current behavior:
 * - Core sub-nav/page title maps are aligned with Spotlight route/title matching.
 * - `_PATCH` values are temporary header/sub-nav overrides where copy has not been unified yet.
 *
 * Direction:
 * - Unify all labels and descriptions with product guidance across Spotlight, headers, and sub-nav.
 */

export const AI_AGENTS_SUB_PAGE_TITLES = {
    [AIAgentPaths.templates]: "Agent Templates",
    [AIAgentPaths.custom]: "AI Agents",
    [AIAgentPaths.knowledgeBase]: "Knowledge Base",
    [`${AIAgentPaths.knowledgeBase}/${aiEditPath}/new`]: "Create Knowledge Base",
} as const;

export const AI_AGENTS_TITLES_PATCH = {
    [AIAgentPaths.templates]: "AI Agent Templates",
} as const;

export const AI_AGENTS_TEMPLATES_REVAMP_DESCRIPTION =
    "Demo AI Phone Agents trained for specific use cases. Clone and edit a template AI Phone Agent to tailor it to your specific business and customer needs.";

export const AI_AGENTS_PAGE_DESCRIPTIONS = {
    [AIAgentPaths.templates]:
        "Discover AI Agent templates. Clone and edit an AI Agent template to tailor it to your specific business and customer needs.",
    [AIAgentPaths.custom]: "Custom AI agent creation and configuration interface.",
    [AIAgentPaths.knowledgeBase]: "Knowledge base management for AI agent training and responses.",
    [`${AIAgentPaths.knowledgeBase}/${aiEditPath}/new`]:
        "Create a new knowledge base for AI agent training and responses.",
} as const;
